import { ItemDetailParams, ItemParams, SalesByStoreRanking } from '@/types/api';
import {
  APPROVAL_AUTHOR_ME_URL as _APPROVAL_AUTHOR_ME_URL,
  APPROVAL_CONFIRM_ME_URL as _APPROVAL_CONFIRM_ME_URL,
  APPROVAL_UNREADREFEEREE_ME_URL as _APPROVAL_UNREADREFEEREE_ME_URL,
} from '@/constant/approval';

export const MYINFO_URL = '/api/auth/apix/my';

export const BIRTHDAY_API_URL = '/api/v1/passport/birthday';

export const BOARD_BASE_API_URL = '/api/v0/board';

export const BOARD_LIKES_API_URL = '/likes';

export const BOARD_COMMENTS_API_URL = '/comments';

export const IMPORTANT_BOARD_URL = '/api/v0/board/filter/important';

export const BOARD_BASE_API_URL_V1 = '/api/v1/board';

export const BOARD_FEEDBACK_V1 = `${BOARD_BASE_API_URL_V1}/feedback`;

export const MY_BOOK_URL = '/api/v0/book/list/my';

export const BOARD_URL = 'https://i.fnf.co.kr/bbs/V';

export const FIND_USER_BASE_URL = '/api/v1/user/findByUserId/';

export const UPDATE_LIKES_URL = `${BOARD_BASE_API_URL}/likes/like`;

export const BOARD_FILTER_URL = `${BOARD_BASE_API_URL}/filter`;

export const UPDATE_COMMENT_LIKE_URL = `${BOARD_BASE_API_URL}${BOARD_COMMENTS_API_URL}/like`;

export const MS_AZURE_LOGIN_URL = `/api/auth/azure/login/url`;

export const MS_AZURE_TOKEN_URL = '/api/auth/azure/token';

export const LOGIN_BY_AZURE_URL = '/api/auth/loginBy/msAzure';

export const LOGIN_BY_ISSUE_PORTAL_TOKEN_URL = '/api/auth/portal/token';

export const LINK_LIST_URL = `/api/v1/link/list/filter`;

export const SEARCH_API_URL = '/api/v2/user/users/search';

export const PASSPORT_BASE_URL = '/api/v1/passport';

export const SEARCH_PASSPORT_URL = `${PASSPORT_BASE_URL}/search`;

export const UPDATE_NICKNAME_URL =
  '/api/v1/portal-user/passport/default/nickname';

export const CHECK_NICKNAME_URL = '/api/v1/passport/nickname/check';
export const UPDATE_NICKNAME_URL_V2 = (id: string) =>
  `/api/v1/control/passport/${id}/nickname`;

export const SEARCH_POINT_URL = '/api/v1/user/findPointByEmployeeNumber';

export const SIGNATURE_URL = 'api/v1/user/getEmailSignature';
export const EMAIL_SIGNATURE_URL = '/api/v1/passport/me/email-signature';

export const CHANGE_PASSWORD_URL = '/api/v1/user/updateUserPassword';

export const GET_CERTIFY_CODE_URL = '/api/auth/code/sms/createCodeAndSendBySms';

export const VERIFY_CERTIFY_CODE_URL =
  '/api/auth/code/sms/checkSmsVerificationCode';

export const EXPIRE_CERTIFY_CODE_URL =
  '/api/auth/code/sms/expireSmsVerificationCode';

export const PRINT_EMP_PROOF_URL =
  '/api/v1/company/hr/getEmploymentVerificationLetter';

export const PROOF_EMP_HISTORY_URL = '/api/v1/company/hr/getHrCart';

export const AUTH_SHOP_ID_URL = '/api/v1/user/authenticateEmployeeOnlineMall';

export const GET_AUTH_SHOP_INFO_URL = '/api/v1/user/getUserCustomerId';

export const CREATE_BOARD_URL = '/api/v0/board/create/creatableBoards';

export const BASE_BOOK_URL = '/api/v0/book';

export const NEW_BOOK_URL = `${BASE_BOOK_URL}/latest`;

export const BOOK_PERIOD_URL = '/api/v0/book/request/period';

export const SEND_EMAIL_URL = '/api/v1/email/sendByTemplate';

export const MS_AZURE_UNREAD_EMAIL_COUNT_URL =
  '/api/v1/labs/msAzureClient/email/unreadCount';

export const FINSTA_FEEDBACK = '/api/v1/labs/finstagram/feedback';
export const FUTUBE_INFO = '/api/v1/labs/fuTube/info';
export const E_LAW_INFO = '/api/v1/labs/eLaw/info';
export const EMAIL_LIST_URL = '/api/v1/labs/msAzureClient/email/messages';
export const CALENDAR_LIST_URL = '/api/v1/labs/msAzureClient/calendar/events';
export const I_READ_BOARD_URL = '/api/v0/board/readers/reader';

export const JIRA_ACCOUNT_URL = '/api/v1/jira/account-id';

export const JIRA_ISSUE_URL = '/api/v1/jira/issues';

export const CREATE_COMMENT_URL = '/api/v0/board/comments';

export const NOTIFICATION_HISTORY_URL = '/api/v1/notificationCenter/history/my';

export const NOTIFICATION_TOPICS_URL = '/api/v1/notificationCenter/topics';

export const CHANGE_PROFILE_URL = '/api/v1/user/update/profileImage';

export const SET_TOKEN_URL = '/api/v1/notificationCenter/tokens/my/create';

export const GET_ACTIVATED_TOKEN_URL =
  '/api/v1/notificationCenter/tokens/my/activated';

export const MESSAGE_READ_URL = '/api/v1/notificationCenter/history/watch';

export const MESSAGE_ALL_READ_URL = `${MESSAGE_READ_URL}/my`;

export const MENU_URL = '/api/v1/menu';

export const PORTAL_PASSPORT_URL = '/api/v1/portal-user/me';

export const PATCH_PASSPORT_URL = '/api/v1/portal-user/passport/default';

export const FILE_UPLOAD_URL = '/api/v1/file/upload';

export const FILE_DOWNLOAD_URL = '/api/v1/file/download';

export const TELECOM_SUPPORT_DOCUMENT_REVIEW_URL =
  '/api/v1/expense-claims/telecom/support-documents/review';

export const TELECOM_SUPPORT_SUBMIT_URL = (id: number) =>
  `/api/v1/expense-claims/telecom/${id}/submit`;

export const MY_NOTIFICATION_OPTION_LIST_URL =
  '/api/v1/notificationCenter/option/my';

export const MY_NOTIFICATION_PORTAL_OPTION_LIST_URL =
  '/api/v1/notificationCenter/portal/option/my';

export const MY_NOTIFICATION_OPTION_URL =
  '/api/v1/notificationCenter/option/update';

export const CHANGE_LANGUAGE_URL = '/api/v1/portal-user/personalization';

export const BASE_CALENDAR_URL = '/api/v1/calendar';

export const CHANGE_JOB_DESCRIPTION_URL = '/api/v1/passport/me/job';

export const JOB_LIST_URL = '/api/v1/passport/job';

export const ORGANIZATION_URL = '/api/v1/organization/relationship/all';
export const ORGANIZATION_PASSPORT_URL = '/api/v1/passports';
export const MENTION_CANDIDATES_URL = `${ORGANIZATION_PASSPORT_URL}/mention-candidates`;

// 전자결재 URL 상수 — constant/approval.ts 에서 관리
export {
  APPROVAL_AUTHOR_ME_URL,
  APPROVAL_CONFIRM_ME_URL,
  APPROVAL_UNREADREFEEREE_ME_URL,
  LEGACY_APPROVAL_ME,
  LEGACY_APPROVAL_AUTHOR_URL,
  LEGACY_APPROVAL_REFERRER_URL,
  LEGACY_APPROVAL_TEAM_AUTHOR_URL,
  LEGACY_APPROVAL_TEAM_APPROVAL_URL,
  APPROVAL_TYPE_ALL_URL,
  LEGACY_APPROVAL_SEARCH_URL,
  COMBINED_DEPARTMENT_URL,
} from '@/constant/approval';

export const ORGANIZATION_BASE_URL = '/api/v1/passport/organization';

export const SALES_URL = '/api/v1/sales';

export const SEASONS_URL = '/api/v1/sales/season';
/** 기준별(상품/운영) 시즌 목록 — date 하나로 두 기준을 함께 내려준다 (PORTAL-14097) */
export const SEASONS_V2_URL = '/api/v2/sales/season';
/**
 * 카테고리 하나의 매출을 시즌별로 분해 (PORTAL-13974).
 * 경로에 season 이 없다 — 상품 시즌 · 전체 전용이라 시즌·기준을 받지 않는다.
 */
export const CATEGORY_SEASON_URL = (brand: string) =>
  `/api/v1/sales/brand/${brand}/product/subcategory/season`;
/** 조회 API 의 시즌 기준 쿼리 파라미터명 — 값은 PRDT(기본) | OPER (PORTAL-13975) */
export const SEASON_BASIS_PARAM = 'seasonType';

export const SALES_MAIN_URL = (season: string) =>
  `/api/v1/sales/season/${season}/brand`;

export const SALES_MAIN_URL_V2 = (season: string) =>
  `/api/v2/sales/season/${season}/brand`;

/** 전년비 비교 기준일 (PORTAL-14709) */
export const SALES_COMPARE_DATE_URL = '/api/v1/sales/compare-date';

export const ALL_STORE_SALES = (season: string, brand: string) =>
  `/api/v2/sales/season/${season}/brand/${brand}/shop`;

export const SHOP_INFO_URL = (
  season: string,
  brand: string,
  shopCode: string,
) => `/api/v1/sales/season/${season}/brand/${brand}/shop/${shopCode}`;

export const SALES_BY_TYPE_URL = (
  season: string,
  brand: string,
  shopCode: string,
) => `${SHOP_INFO_URL(season, brand, shopCode)}/type`;

export const SALES_BY_BEST_URL = (
  season: string,
  brand: string,
  shopCode: string,
) => `${SHOP_INFO_URL(season, brand, shopCode)}/best`;

export const SALES_BY_BEST_V2_URL = (
  season: string,
  brand: string,
  shopCode: string,
) => `${SHOP_INFO_URL(season, brand, shopCode)}/product/best`;

export const ITEM_SALES_DETAIL_URL = ({
  season,
  brand,
  productCode,
  shopCode,
}: ItemDetailParams) =>
  `/api/v1/sales/season/${season}/brand/${brand}/shop/${shopCode}/product/${productCode}/best`;

export const BEST_SHOP_URL = ({
  season,
  brand,
  productCode,
  colorCode,
}: SalesByStoreRanking) =>
  `/api/v1/sales/season/${season}/brand/${brand}/shop/product/${productCode}/color/${colorCode}`;

export const RIVAL_RANK_URL = '/api/v1/sales/daily-rival-rank';

export const RIVAL_RANK_STANDARD_COMPANY_URL = (
  brand: string,
  shopCode?: string,
) =>
  `/api/v1/sales/daily-rival-rank/brand/${brand}${
    shopCode ? `/shop/${shopCode}` : ''
  }`;

export const RIVAL_RANK_STORE_URL = (brand: string) =>
  `/api/v1/sales/daily-rival-rank/brand/${brand}/shop`;

export const WEATHER_URL = '/api/v1/labs/dataOpenApi/weather/forecast';

export const SALES_ANALYSIS_URL = '/api/v1/sales/analysis/brand';

export const SALES_BY_CHANNEL_URL = (brand: string) =>
  `${SALES_ANALYSIS_URL}/${brand}/channel`;

export const SALES_BY_SEASON_URL = (brand: string) =>
  `${SALES_ANALYSIS_URL}/${brand}/season`;

export const SALES_BY_Item_URL = (brand: string) =>
  `${SALES_ANALYSIS_URL}/${brand}/apparel-and-accessories`;

export const PRODUCT_DETAIL_URL = ({
  season,
  brand,
  productCode,
  date,
}: ItemParams) =>
  `/api/v1/sales/season/${season}/brand/${brand}/product/${productCode}?date=${date}`;

export const PRODUCT_SALES_BY_COLORS_URL = ({
  season,
  brand,
  productCode,
  date,
}: ItemParams) =>
  `/api/v1/sales/season/${season}/brand/${brand}/product/${productCode}/color?date=${date}`;

export const PASSPORT_SYNCED_TIME_URL =
  '/api/v1/passport/issuer/synced-at/latest';

export const BRAND_PERMISSION_MISSING_URL = '/api/v1/sales/permissions/missing';

export const PING_URL = '/api/ping';

export const HISTORY_BASE_URL = '/api/v1/history';

export const SEARCH_EMP_HISTORY_URL = `${HISTORY_BASE_URL}/passport/quick-search`;
export const PASSPORT_SEARCH_URL = `${HISTORY_BASE_URL}/passport/keyword`;

export const DELETE_PASSPORT_URL = `${SEARCH_EMP_HISTORY_URL}/data`;

export {
  LEGACY_APPROVAL_RECENT_READ,
  APPROVAL_RECOMMEND_FILTER_URL,
  APPROVAL_RECENT_SEARCH_KEYWORD,
} from '@/constant/approval';

export const SEARCH_GPT_EMPLOYEE_URL = '/api/v1/passport/nl-search';

export { APPROVAL_FAVORITE_FILTER } from '@/constant/approval';

export const BASE_FAQ_CHATBOT = `/proxy/faq-chatbot`;
export const FAQ_SESSION_URL = `${BASE_FAQ_CHATBOT}//api/chat/session`;

export const FAQ_MESSAGE_URL = (session_id: string) =>
  `${BASE_FAQ_CHATBOT}//api/chat/session/${session_id}/message`;

export const QR_NUM_URL = '/api/v1/passport/me/center-pass/card-number';

export const BASE_FRESH_FARM_URL = '/api/v1/fresh-farm';

export const CONGESTION_URL = `${BASE_FRESH_FARM_URL}/congestion`;

export const BASE_TALK_FLOW_URL = '/api/v1/talk-flow';

export const AI_TRANSLATION_URL = '/api/v1/labs/translation/basic/text';
export const POPUP_LIST = `/api/v1/popup/me`;

export const EVENT_BANNER_LIST = `/api/v1/event-banners/me`;
export const CONTENT_BANNER_LIST = `/api/v1/content-banners/me`;

export const POPUP_DISMISSAL = (popupId: string) =>
  `/api/v1/popup/${popupId}/dismissal`;

export const SA_HOLIDAY = '/api/v1/labs/sa/holiday/count';
export const SA_NO_APPROVAL = '/api/v1/labs/sa/pending/count';
export const SA_APPROVAL_REJECT_TAX = '/api/v1/labs/sa/tax/rejected/count';
export const SA_APPROVAL_REJECT_CARD = '/api/v1/labs/sa/card/rejected/count';
export const SA_MONTHLY_TOTAL_PRICE = '/api/v1/labs/sa/card/monthly/price';
export const SA_UNSETTLED_TAX_COUNT = '/api/v1/labs/sa/tax/unsettled/count';
export const SA_UNSETTLED_CARD_COUNT = '/api/v1/labs/sa/card/unsettled/count';

export {
  APPROVAL_MARKETING_AI_PARAMETERS,
  APPROVAL_MARKETING_AI_SUMMARY,
  APPROVAL_MARKETING_AI_ANALYSIS,
  APPROVAL_MARKETING_ANALYSIS,
  APPROVAL_INTERIOR_COST_ADEQUACY,
  APPROVAL_INTERIOR_SETTLEMENT,
} from '@/constant/approval';

export const MARKETING_BUDGET = '/api/v1/labs/sap/marketing/budget';
export const MARKETING_PARTNER = '/api/v1/labs/sap/business/partner';

export enum RevalidateApi {
  Approval = 'approval',
  SA = 'sa',
}
export const revalidateApiList: Map<RevalidateApi, string[]> = new Map([
  [
    RevalidateApi.Approval,
    [
      _APPROVAL_AUTHOR_ME_URL,
      _APPROVAL_CONFIRM_ME_URL,
      _APPROVAL_UNREADREFEEREE_ME_URL,
    ],
  ],
  [
    RevalidateApi.SA,
    [
      SA_HOLIDAY,
      SA_UNSETTLED_TAX_COUNT,
      SA_UNSETTLED_CARD_COUNT,
      SA_NO_APPROVAL,
      SA_APPROVAL_REJECT_TAX,
      SA_APPROVAL_REJECT_CARD,
    ],
  ],
]);
